<template>
  <el-dialog custom-class="min-dialog" title="首次使用，需要初始化数据" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :modal-append-to-body="false">
    <el-form  status-icon  label-width="100px" class="demo-ruleForm">
      <el-form-item label=" " >
        <h1>我是老板：</h1><el-button type="success" round style="margin-left: 100px" :loading="loading" @click="register">我要开通《眼镜智慧通》企业账号</el-button>
      </el-form-item>
      <el-form-item label=" " >
        <h1>我是员工：</h1><el-button type="info" round style="margin-left: 100px" :disabled="true">请等待老板授权！</el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
  //import {sysmanagesaveData} from '../../api/sysmanage/sysmanage'

  export default {
    data() {
      return {
        title: '',
        loading: false,
        mobile: '',
        dialogFormVisible: false,
      };
    },
    methods: {
      register() {
        this.loading = true;
        // sysmanagesaveData({tenantname:this.mobile,contactname:this.mobile,contactphone:this.mobile}).then(response => {
        //   if (response.data.code == 0) {//注册成功
        //this.$emit("AfterRegister");

        this.$router.push("/Register");

        //this.dialogFormVisible = false;
        // } else {
        //   this.$message.error({message: '开通失败！'});
        // }
        // }).catch((error) => {
        //   console.log(error)
        // });
      },
      submitForm() {

      },
      show(mobile) {
        this.mobile=mobile;
        this.dialogFormVisible = true;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/RegisterPre.vue